<select [ngModel]="country" (ngModelChange)="onChange($event)" class="form-control">
  <option *ngFor="let n of countries" [value]="n.dial_code">
    {{n.name}}
  </option>
</select>
